import type { DischargeRequestProperty } from '@/types/DischargeRequest';
import { yupArray, yupNumber, yupObject, yupString } from '../../yup';

export const dischargeRequestPropertySchema = yupObject<DischargeRequestProperty>({
  repaidByWayOf: yupString().required().label('Repaid way of'),
  propertyId: yupString()
    .when('repaidByWayOf', ([repaidByWayOf], schema) =>
      ['property_sold', 'refinance'].includes(repaidByWayOf) ? schema.required() : schema,
    )
    .label('Property'),
  nameOfInstitution: yupString()
    .when('repaidByWayOf', ([repaidByWayOf], schema) =>
      ['refinance', 'cash_repayment'].includes(repaidByWayOf) ? schema.required() : schema,
    )
    .label('Name of institution'),
  forUploadDocuments: yupArray().min(1).label('Document'),
  date: yupString().required().label('Date'),
  amount: yupNumber().required().min(0).label('Amount'),
});
